import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative flex flex-col items-center justify-center pt-24 pb-12 overflow-hidden" data-id="element-54">
      {/* Background Glow */}
      <div className="absolute inset-0 bg-radial-purple opacity-70 pointer-events-none" data-id="element-55" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-56">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass-card mb-8 border-brand-cyan/20" data-id="element-57">
          <span className="w-2 h-2 rounded-full bg-brand-cyan animate-pulse" data-id="element-58" />
          <span className="text-brand-cyan text-sm font-medium tracking-wide uppercase" data-id="element-59">
            AI Pilot Society
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="font-display text-3xl sm:text-5xl md:text-7xl font-bold text-white leading-[1.1] mb-6 tracking-tight" data-id="element-60">
          AI PILOT SOCIETY
          <br data-id="element-61" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-cyan to-white/60 text-2xl sm:text-4xl md:text-6xl" data-id="element-62">
            Domina el Sistema de Ingresos 360
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-base sm:text-lg md:text-xl text-brand-cyan/80 max-w-2xl mx-auto mb-10 font-light leading-relaxed px-2" data-id="element-63">
          <strong className="font-medium text-white" data-id="element-64">
            IA + Ventas + Trading
          </strong>
          . Instala el Stack del Operador Digital y escala tus resultados hoy.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex justify-center" data-id="element-65">
          <button onClick={() => document.getElementById('cta')?.scrollIntoView({
          behavior: 'smooth'
        })} className="group relative inline-flex items-center gap-3 px-8 py-4 rounded-full bg-brand-cyan text-black font-bold text-base sm:text-lg transition-all duration-300 btn-glow-cyan hover:bg-brand-cyan/90 overflow-hidden" data-id="element-66">
            <span className="relative z-10" data-id="element-67">Instalar el Sistema</span>
            <ArrowRight className="w-5 h-5 relative z-10 group-hover:translate-x-1 transition-transform" data-id="element-68" />
            <div className="absolute inset-0 bg-gradient-to-r from-brand-cyan via-white/20 to-brand-cyan opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-69" />
          </button>
        </motion.div>
      </div>

      {/* Hero Banner Image */}
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.6,
      ease: [0.16, 1, 0.3, 1]
    }} className="relative z-10 w-full max-w-5xl mx-auto px-6 mt-16" data-id="element-70">
        <div className="relative rounded-2xl overflow-hidden glass-card p-1.5" data-id="element-71">
          <img src="https://cdn.magicpatterns.com/uploads/ki8KbQWfxHmEEpS5UWnVhv/banner_l.png" alt="Sistema de Ingresos 360 — AI Dashboard, Trading & Sales Setup" className="w-full rounded-xl" data-id="element-72" />
          <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-transparent to-transparent opacity-40 pointer-events-none" data-id="element-73" />
        </div>
      </motion.div>
    </section>;
}